(function () {
  'use strict';

  /* ============================================================
     AÇÃO LA ROCHE (03–16/Ago/2026) — barra progressiva 2 ETAPAS
     no cart drawer (Kaching), substituindo a barra de 1 etapa.

     Etapa 1: frete grátis (STAGE1)
     Etapa 2: R$ 384,90 → Sérum de Olhos Hyalu B5 GRÁTIS (STAGE2)

     O que faz:
       - Esconde via CSS a tiered-promotions-bar nativa do Kaching
         (some junto com o rollback deste asset; config do app intocada).
       - Injeta uma barra própria (classes gd-lr-*) no MESMO lugar,
         com 2 marcos, mensagem dinâmica e animação ao cruzar etapa.

     Comportamentos não-óbvios:
       - Kaching (React) APAGA DOM injetado a cada re-render →
         re-injeção via MutationObserver debounced no <body>
         (mesmo padrão do ab01-cart-upsell.js).
       - Progresso lê /cart.js: items_subtotal_price MENOS a linha do
         brinde — casa com a régua do Vex ("cart subtotal before order
         discounts") e evita que o sérum (R$200 riscados) pule a barra.
       - Quem ADICIONA o brinde e aplica o desconto é o Vex (backend).
         Esta barra é só a comunicação visual do funil.
       - prevStage vive em window.__GD_LR_PREV_STAGE: re-inject do
         observer com o mesmo estágio NÃO re-anima (só cruzamento real).

     Rollback: remover a linha do theme.liquid (a barra nativa volta
     sozinha, pois o hide vive no CSS deste asset).
     ============================================================ */

  try {

    if (window.__GD_LR_BAR_LOADED) return;
    window.__GD_LR_BAR_LOADED = true;

    /* ======================== CONFIG ======================== */

    // STAGE1 = frete grátis. Confirmado 03/Ago: config do Kaching (tier threshold:200)
    // + teste empírico do Frenet (libera entre R$189,81–199,80 no preço cheio).
    var STAGE1 = 200.00;
    var STAGE2 = 384.90;
    var GIFT_VARIANT_ID = 53242273235253; // Sérum de Olhos Hyalu B5
    var GIFT_VALUE_LABEL = 'R$&nbsp;200';
    var TIER1_POS = 52;   // % visual do marco 1 na barra
    var NAVY = 'rgb(29,41,57)';

    var ROOT_ID = 'gd-lr-bar';
    var STYLE_ID = 'gd-lr-css';

    /* ======================== CSS ======================== */

    function injectCSS() {
      if (document.getElementById(STYLE_ID)) return;
      var css = '' +
        /* esconde a barra nativa do Kaching enquanto este asset existir */
        '.kaching-cart__tiered-promotions-bar{display:none !important;}' +

        '#' + ROOT_ID + '{padding:4px 24px 58px;}' +
        '#' + ROOT_ID + ' .gd-lr-text{text-align:center;font-size:14px;color:#111;margin:0 0 12px;line-height:1.4;}' +
        '#' + ROOT_ID + ' .gd-lr-text s{color:#999;}' +
        '#' + ROOT_ID + ' .gd-lr-track{position:relative;width:100%;height:12px;background:#ececec;border-radius:3px;}' +
        '#' + ROOT_ID + ' .gd-lr-fill{height:100%;width:0%;background:' + NAVY + ';border-radius:3px;transition:width .6s cubic-bezier(.22,.8,.35,1);font-size:0;}' +
        '#' + ROOT_ID + ' .gd-lr-tier{position:absolute;top:50%;z-index:2;}' +
        '#' + ROOT_ID + ' .gd-lr-tier>svg{width:20px;height:20px;display:block;}' +
        '#' + ROOT_ID + ' .gd-lr-tier.gd-lr-pop>svg{animation:gd-lr-pop .5s cubic-bezier(.34,1.56,.64,1);}' +
        '@keyframes gd-lr-pop{0%{transform:scale(1)}50%{transform:scale(1.35)}100%{transform:scale(1)}}' +
        '#' + ROOT_ID + ' .gd-lr-tip{position:absolute;top:26px;display:flex;flex-direction:column;gap:2px;}' +
        '#' + ROOT_ID + ' .gd-lr-tip svg{width:16px;height:16px;}' +
        '#' + ROOT_ID + ' .gd-lr-tip-title{font-size:12px;font-weight:600;color:' + NAVY + ';white-space:nowrap;}' +
        '#' + ROOT_ID + ' .gd-lr-tier--1{left:' + TIER1_POS + '%;transform:translate(-50%,-50%);}' +
        '#' + ROOT_ID + ' .gd-lr-tier--1 .gd-lr-tip{left:50%;transform:translateX(-50%);align-items:center;text-align:center;}' +
        '#' + ROOT_ID + ' .gd-lr-tier--2{right:-2px;transform:translateY(-50%);}' +
        '#' + ROOT_ID + ' .gd-lr-tier--2 .gd-lr-tip{right:0;align-items:flex-end;text-align:right;}';
      var st = document.createElement('style');
      st.id = STYLE_ID;
      st.textContent = css;
      document.head.appendChild(st);
    }

    /* ======================== HELPERS ======================== */

    function brl(cents) {
      var v = (cents / 100).toFixed(2).replace('.', ',');
      return 'R$&nbsp;' + v;
    }

    function getCart() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); });
    }

    // subtotal em CENTS: itens antes de desconto de pedido, SEM o brinde
    function promoTotal(cart) {
      var total = cart.items_subtotal_price || 0;
      (cart.items || []).forEach(function (it) {
        if (it.variant_id === GIFT_VARIANT_ID) {
          total -= (it.final_line_price != null ? it.final_line_price : it.line_price) || 0;
        }
      });
      return total;
    }

    function stageOf(totalCents) {
      if (totalCents >= STAGE2 * 100) return 2;
      if (totalCents >= STAGE1 * 100) return 1;
      return 0;
    }

    function fillPct(totalCents) {
      var t = totalCents / 100;
      if (t <= 0) return 0;
      if (t < STAGE1) return (t / STAGE1) * TIER1_POS;
      if (t < STAGE2) return TIER1_POS + ((t - STAGE1) / (STAGE2 - STAGE1)) * (100 - TIER1_POS);
      return 100;
    }

    /* ======================== MARKUP ======================== */

    var SVG_SQUARE_OPEN =
      '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="0" y="0" width="20" height="20" fill="' + NAVY + '" stroke="' + NAVY + '" stroke-width="2"></rect>' +
      '<rect class="gd-lr-inner" x="4" y="4" width="12" height="12" fill="white" stroke="white" stroke-width="2"></rect>' +
      '</svg>';

    var SVG_TRUCK =
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">' +
      '<path d="M2 6.5h12.5V16H2z" stroke="' + NAVY + '" stroke-width="2" stroke-linejoin="round"/>' +
      '<path d="M14.5 9.5h3.6L21 12.4V16h-6.5z" stroke="' + NAVY + '" stroke-width="2" stroke-linejoin="round"/>' +
      '<circle cx="6.5" cy="17.5" r="1.9" fill="#fff" stroke="' + NAVY + '" stroke-width="2"/>' +
      '<circle cx="17" cy="17.5" r="1.9" fill="#fff" stroke="' + NAVY + '" stroke-width="2"/></svg>';

    var SVG_GIFT =
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
      '<path d="M7.99992 4V14.6667M7.99992 4H5.64278C5.29547 4 4.96239 3.85952 4.7168 3.60947C4.47122 3.35943 4.33325 3.02029 4.33325 2.66667C4.33325 2.31304 4.47122 1.9739 4.7168 1.72386C4.96239 1.47381 5.29547 1.33333 5.64278 1.33333C7.47611 1.33333 7.99992 4 7.99992 4ZM7.99992 4H10.3571C10.7044 4 11.0375 3.85952 11.283 3.60947C11.5286 3.35943 11.6666 3.02029 11.6666 2.66667C11.6666 2.31304 11.5286 1.9739 11.283 1.72386C11.0375 1.47381 10.7044 1.33333 10.3571 1.33333C8.52373 1.33333 7.99992 4 7.99992 4ZM13.3333 7.33333V12.5333C13.3333 13.2801 13.3333 13.6534 13.1879 13.9387C13.0601 14.1895 12.8561 14.3935 12.6052 14.5213C12.32 14.6667 11.9467 14.6667 11.1999 14.6667L4.79992 14.6667C4.05318 14.6667 3.67981 14.6667 3.3946 14.5213C3.14372 14.3935 2.93974 14.1895 2.81191 13.9387C2.66659 13.6534 2.66659 13.2801 2.66659 12.5333V7.33333M1.33325 5.06667L1.33325 6.26667C1.33325 6.64003 1.33325 6.82672 1.40591 6.96933C1.46983 7.09477 1.57182 7.19675 1.69726 7.26067C1.83987 7.33333 2.02655 7.33333 2.39992 7.33333L13.5999 7.33333C13.9733 7.33333 14.16 7.33333 14.3026 7.26067C14.428 7.19675 14.53 7.09477 14.5939 6.96933C14.6666 6.82672 14.6666 6.64003 14.6666 6.26667V5.06667C14.6666 4.6933 14.6666 4.50661 14.5939 4.36401C14.53 4.23856 14.428 4.13658 14.3026 4.07266C14.16 4 13.9733 4 13.5999 4L2.39992 4C2.02655 4 1.83987 4 1.69726 4.07266C1.57182 4.13658 1.46983 4.23856 1.40591 4.36401C1.33325 4.50661 1.33325 4.6933 1.33325 5.06667Z" stroke="' + NAVY + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

    function barHTML() {
      return '' +
        '<p class="gd-lr-text"></p>' +
        '<div class="gd-lr-track">' +
          '<div class="gd-lr-fill">&nbsp;</div>' +
          '<div class="gd-lr-tier gd-lr-tier--1">' + SVG_SQUARE_OPEN +
            '<div class="gd-lr-tip">' + SVG_TRUCK + '<span class="gd-lr-tip-title gd-lr-t1"></span></div>' +
          '</div>' +
          '<div class="gd-lr-tier gd-lr-tier--2">' + SVG_SQUARE_OPEN +
            '<div class="gd-lr-tip">' + SVG_GIFT + '<span class="gd-lr-tip-title gd-lr-t2"></span></div>' +
          '</div>' +
        '</div>';
    }

    /* ======================== RENDER ======================== */

    var lastKey = null;
    var rendering = false;

    function applyState(root, totalCents) {
      var stage = stageOf(totalCents);
      var msg = root.querySelector('.gd-lr-text');
      var fill = root.querySelector('.gd-lr-fill');
      var t1 = root.querySelector('.gd-lr-tier--1');
      var t2 = root.querySelector('.gd-lr-tier--2');

      fill.style.width = fillPct(totalCents) + '%';
      t1.querySelector('.gd-lr-inner').setAttribute('fill', stage >= 1 ? NAVY : 'white');
      t2.querySelector('.gd-lr-inner').setAttribute('fill', stage >= 2 ? NAVY : 'white');
      root.querySelector('.gd-lr-t1').textContent = (stage >= 1 ? '✅ ' : '') + 'Frete Grátis';
      root.querySelector('.gd-lr-t2').textContent = (stage >= 2 ? '✅ ' : '🎁 ') + 'Sérum La Roche';

      if (stage === 0) {
        msg.innerHTML = 'Faltam <strong>' + brl(STAGE1 * 100 - totalCents) + '</strong> para o <strong>Frete Grátis</strong>!';
      } else if (stage === 1) {
        msg.innerHTML = 'Faltam <strong>' + brl(STAGE2 * 100 - totalCents) + '</strong> para o <strong>Sérum La&nbsp;Roche-Posay</strong> (<s>' + GIFT_VALUE_LABEL + '</s> GRÁTIS)';
      } else {
        msg.innerHTML = '<strong>Frete Grátis</strong> e <strong>Sérum La&nbsp;Roche-Posay</strong> desbloqueados! 🎉';
      }

      // anima só quando CRUZA uma etapa de verdade (não no re-inject)
      var prev = (typeof window.__GD_LR_PREV_STAGE === 'number') ? window.__GD_LR_PREV_STAGE : null;
      if (prev !== null && stage > prev) {
        var t = stage === 1 ? t1 : t2;
        t.classList.remove('gd-lr-pop');
        void t.offsetWidth;
        t.classList.add('gd-lr-pop');
      }
      window.__GD_LR_PREV_STAGE = stage;
    }

    function findAnchor() {
      var drawer = document.querySelector('kaching-cart-drawer .kaching-cart__contents') ||
                   document.querySelector('.kaching-cart__contents');
      if (!drawer) return null;
      // preferir o module que contém a barra nativa (escondida) → mesma posição
      var nativeBar = drawer.querySelector('.kaching-cart__tiered-promotions-bar');
      var anchor = null;
      if (nativeBar) {
        anchor = nativeBar.closest('.kaching-cart__module') || nativeBar;
      }
      return { drawer: drawer, anchor: anchor };
    }

    function render() {
      var spot = findAnchor();
      if (!spot) return;
      if (rendering) return;
      rendering = true;

      getCart().then(function (cart) {
        var total = promoTotal(cart);
        var key = total + '|' + stageOf(total);

        spot = findAnchor();
        if (!spot) { rendering = false; return; }

        var existing = document.getElementById(ROOT_ID);
        if (existing && spot.drawer.contains(existing) && key === lastKey) {
          rendering = false;
          return;
        }

        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

        var root = document.createElement('div');
        root.id = ROOT_ID;
        root.innerHTML = barHTML();

        if (spot.anchor && spot.anchor.parentNode) {
          spot.anchor.parentNode.insertBefore(root, spot.anchor.nextSibling);
        } else {
          spot.drawer.insertBefore(root, spot.drawer.firstChild);
        }

        // aplica estado no frame seguinte pra transição de width animar do 0
        requestAnimationFrame(function () { applyState(root, total); });

        lastKey = key;
        rendering = false;
      }).catch(function (e) {
        rendering = false;
        console.warn('[LAROCHE-BAR] cart fetch failed:', e);
      });
    }

    /* ======================== OBSERVER ======================== */

    function observe() {
      var scheduled = false;
      var mo = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          var drawer = document.querySelector('kaching-cart-drawer .kaching-cart__contents') ||
                       document.querySelector('.kaching-cart__contents');
          if (drawer) render();
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
      window.__GD_LR_MO = mo;
    }

    function waitForElement(selector, cb, interval, timeout) {
      var waited = 0;
      var timer = setInterval(function () {
        var el = document.querySelector(selector);
        if (el) { clearInterval(timer); cb(el); return; }
        waited += interval;
        if (waited >= timeout) clearInterval(timer);
      }, interval);
    }

    /* ======================== BOOT ======================== */

    injectCSS();
    waitForElement('kaching-cart-drawer .kaching-cart__contents, .kaching-cart__contents', function () {
      render();
      observe();
    }, 50, 20000);

  } catch (e) {
    console.warn('[LAROCHE-BAR] fatal error:', e);
  }
})();
